import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const babyAndMammyReOpening: BlogMetaData = {
  title:
    'モンテッソーリ教育を初めてみたいけど、いきなり保育園は...という方へ、気軽にモンテを始められる幼児教室再開のお知らせ',
  description: '一時受付を停止していた、ベビーマミークラスの再開についてのお知らせです。',
  thumbnailUrl: '/img/first-view-image1.webp',
  filePath: buildBlogFilePath('baby-mammy-re-opening'),
  category: BLOG_CATEGORY.NEWS,
};
